module.exports = __webpack_public_path__ + "img/trail_of_bing_bongs_candy_tears.0eab7249.jpg";